module.exports = __webpack_public_path__ + "media/images/map/left-arrow-9794d2610a80f8327363343245415dde.svg";